import {gql} from "@apollo/client";

export const getPlates = gql`
  query getList {
    plates {
      id
      name
      image
      details
      ingredientsCount
    }
  }
`

export const getPlateById = gql`
  query getItem($id: ID!) {
    plate( id: $id) {
      id
      name
      image
      details
      ingredientsCount
      ingredients {
        id, name
      }
    }
  }
`

export const createPlateMutation = gql`
  mutation createPlate($name: String!, $details: String, $image: String){
    createPlate(
      input: {
        name: $name,
        details: $details,
        image: $image,
      }) {
      plate {
        id
      }
    }
  }
`

export const updatePlateMutation = gql`
  mutation updatePlate(
    $id: ID!, $name: String!, $details: String, $image: String
  ){
    updatePlate(
      input: {
        id: $id,
        name: $name,
        details: $details,
        image: $image,
      }) {
      plate {
        id
      }
    }
  }
`

export const deletePlateMutation = gql`
  mutation deletePlate($id: ID!){
    deletePlate(
      input: {id: $id}) {
      plate {
        id
      }
    }
  }
`

export const getPlateIngredients = gql`
  query getPlateIngredients($plateId: ID!) {
    plateIngredients(plateId: $plateId) {
      id
      qty
      qtyInfo
      plateId
      ingredient {
        id
        name
        details
      }
      unit {
        id
        name
      }
    }
  }
`

export const getIngredientsForPlate = gql`
  query getIngredientsForPlate($plateId: ID!) {
    ingredientsForPlate(plateId: $plateId) {
      id
      name
      details
    }
  }
`

export const AddPlateIngredient = gql`
  mutation addPlateIngredient($plateId: ID!, $ingredientId: ID!, $qty: String, $unitId: ID, $qtyInfo: String){
    addPlateIngredient(
      input: {
        plateId: $plateId, ingredientId: $ingredientId,
        qty: $qty, unitId: $unitId, qtyInfo: $qtyInfo
      }) {
      plate {
        id
      }
    }
  }
`

export const UpdatePlateIngredient = gql`
  mutation updatePlateIngredient($id: ID!, $plateId: ID!, $ingredientId: ID!, $qty: String, $unitId: ID, $qtyInfo: String){
    updatePlateIngredient(
      input: {
        id: $id, plateId: $plateId, ingredientId: $ingredientId,
        qty: $qty, unitId: $unitId, qtyInfo: $qtyInfo
      }) {
      plate {
        id
      }
    }
  }
`
export const deletePlateIngredientMutation = gql`
  mutation deletePlateIngredient($id: ID!){
    deletePlateIngredient(
      input: { id: $id}
    ) {
      plate {
        id
      }
    }
  }
`